import { SidebarSimple } from "@phosphor-icons/react";
import { Button, Sheet, SheetClose, SheetContent, SheetTrigger } from "@reactive-resume/ui";
import { motion } from "framer-motion";
import { useState } from "react";
import { Outlet } from "react-router";

import { Sidebar } from "./_components/sidebar";
import { t } from "@lingui/macro";
import { useUser } from "@/client/services/user";
import { useLingui } from "@lingui/react";

export const DashboardLayout = () => {
  const [open, setOpen] = useState(false);
  const { user } = useUser();

  const getTrialTimeRemaining = () => {
    if (!user?.isFreeTrial || !user?.createdAt) return null;

    const trialEndTime = new Date(user.createdAt).getTime() + 14 * 24 * 60 * 60 * 1000;
    const now = new Date().getTime();
    const remainingMs = Math.max(0, trialEndTime - now);

    if (remainingMs === 0) return null;

    const days = Math.floor(remainingMs / (24 * 60 * 60 * 1000));
    const hours = Math.floor((remainingMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    const minutes = Math.floor((remainingMs % (60 * 60 * 1000)) / (60 * 1000));

    if (days > 0) {
      return t`${days} day${days !== 1 ? "s" : ""} and ${hours} hour${hours !== 1 ? "s" : ""}`;
    } else if (hours > 0) {
      return t`${hours} hour${hours !== 1 ? "s" : ""} and ${minutes} minute${minutes !== 1 ? "s" : ""}`;
    } else {
      return t`${minutes} minute${minutes !== 1 ? "s" : ""}`;
    }
  };

  const trialTimeRemaining = getTrialTimeRemaining();

  return (
    <div>
      <div className="sticky top-0 z-50 flex items-center justify-between p-4 pb-0 lg:hidden">
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Button size="icon" variant="ghost" className="bg-background">
              <SidebarSimple />
            </Button>
          </SheetTrigger>

          <SheetContent showClose={false} side="left" className="focus-visible:outline-none">
            <SheetClose asChild className="absolute top-4 left-4">
              <Button size="icon" variant="ghost">
                <SidebarSimple />
              </Button>
            </SheetClose>

            <Sidebar setOpen={setOpen} />
          </SheetContent>
        </Sheet>
      </div>

      <motion.div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-[320px] lg:flex-col">
        <div className="h-full rounded p-4">
          <Sidebar />
        </div>
      </motion.div>

      <main className="mx-6 my-4 lg:mx-8 lg:pl-[320px]">
        {user?.isFreeTrial && (
          <div className="mb-3 rounded-lg bg-yellow-600 px-4 py-1.5 text-center font-semibold dark:bg-red-700">
            <span className="font-extrabold">{trialTimeRemaining}</span>{" "}
            {t`remaining on free trial`}
          </div>
        )}
        <Outlet />
      </main>

      <a
        href="https://www.trustpilot.com/review/cvkit.ai"
        target="_blank"
        rel="noopener"
        className="fixed right-3 bottom-3 rounded border border-[#00b67a] bg-white px-3 py-2 text-center"
      >
        <div className="flex items-center justify-center gap-2">
          <strong>{t`Review us on `}</strong>
          <svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" viewBox="0 0 24 24">
            {/* Icon from Simple Icons by Simple Icons Collaborators - https://github.com/simple-icons/simple-icons/blob/develop/LICENSE.md */}
            <path
              fill="#00b67a"
              d="m17.227 16.67l2.19 6.742l-7.413-5.388zM24 9.31h-9.165L12.005.589l-2.84 8.723L0 9.3l7.422 5.397l-2.84 8.714l7.422-5.388l4.583-3.326z"
            />
          </svg>
          TrustPilot
        </div>
      </a>
    </div>
  );
};
